export default __webpack_public_path__ + "static/media/742.5ba6e0e3.png";